import React, { useState } from 'react';
import { cloudImg } from '../../general';
import './Lightbox.css';
import cataloguesDelete from '../../api/cataloguesDelete';
import cataloguesDeleteImage from '../../api/cataloguesDeleteImage';
import BoxHeader from './BoxHeader';

const Image = ({ image, hash }) => {
  const [show, setShow] = useState(true);
  const del = () => {
    cataloguesDeleteImage(hash, { imageId: image.id })
      .then((res) => {
        if (res.status === 204) {
          setShow(false);
        }
      });
  };
  return (show && (
    <div className="lightbox_image">
      <img className="lightbox_image_img" src={cloudImg(image.thumb.crop_3)} alt={cloudImg(image.thumb.crop_3)} />
      <div onClick={del} className="lightbox_image_remove">
        Remove
      </div>
    </div>
  ));
};

export default ({ title, hash, images }) => {
  const [show, setShow] = useState(true);
  const [showBox, setShowBox] = useState(false);
  const del = () => {
    cataloguesDelete(hash)
      .then((res) => {
        if (res.status === 204) {
          setShow(false);
          setShowBox(false);
        }
      });
  };

  return (
    <>
      {show && (
        <div className="lightbox">
          <p className="lightbox_title">{title}</p>
          <BoxHeader setShowBox={setShowBox} hash={hash} />
          <div className="lightbox_images">
            {images.map((image) => <Image image={image} hash={hash} />)}
          </div>
        </div>
      )}
      {showBox && (
        <div className="lightbox_delete_overlay">
          <div className="lightbox_delete_overlay_box">
            <p className="lightbox_delete_overlay_text">
              {`Do you really want to delete ${title}?`}
            </p>
            <button onClick={del} type="button" className="lightbox_form_box">
              Yes
            </button>
            <button onClick={() => setShowBox(false)} type="button" className="lightbox_form_box">
              No
            </button>
          </div>
        </div>
      )}
    </>
  );
};
